import { render, staticRenderFns } from "./BudgetLimitSecond.vue?vue&type=template&id=6599bba8&scoped=true&"
import script from "./BudgetLimitSecond.vue?vue&type=script&lang=js&"
export * from "./BudgetLimitSecond.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6599bba8",
  null
  
)

export default component.exports